import { Spinner } from '@c2fo/liquidity';

interface LoadingStepProps {
  message: string;
}

const LoadingStep = ({ message }: LoadingStepProps) => {
  return (
    <div className="flex flex-col justify-center gap-8">
      <div className="flex w-full justify-center">
        <Spinner className="h-[70px] w-[70px] fill-primary-500" />
      </div>
      <p className="pb-6">{message}</p>
    </div>
  );
};

export default LoadingStep;
